import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView,
}                               from 'rewire-ui';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import addReasonDialogModel     from './AddReasonDialogModel';
import { withStyles }           from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface IAddReasonDialogProps {
}

type AddReasonDialogProps = WithStyle<ReturnType<typeof styles>, IAddReasonDialogProps>;

class AddReasonDialog extends React.PureComponent<AddReasonDialogProps> {
  constructor(props: AddReasonDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    addReasonDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={addReasonDialogModel.form} onSubmit={addReasonDialogModel.actionFn('save')}>
        {addReasonDialogModel.form.fields.map((field: any) =>
          <div key={field.name} className='content'>
            <field.Editor className='span1' />
          </div>
        )}
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: addReasonDialogModel}} DraggableResizableBoxProps={{minWidth: '250px', minHeight: '358px'}} >
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAddReasonDialogProps>(styles, AddReasonDialog);
